<template>
    <path
        fill="currentColor"
        d="M14.273 6.235a1.999 1.999 0 0 1 0 3.529L5.731 14.409C4.356 15.158 2.667 14.185 2.667 12.645V3.355c0-1.54 1.689-2.513 3.064-1.765z"
    />
</template>
